import React, { useEffect, useState } from 'react';
import { CalendarClock, Loader2, RefreshCw, Sparkles } from 'lucide-react';
import { api } from '../../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const kiStream = async (pfad, body, onText, onMeta) => {
  const r = await fetch(`${API}${pfad}`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });
  if (!r.ok) { let d = ''; try { d = (await r.json()).detail; } catch { /* leer */ } throw new Error(d || 'KI-Anfrage fehlgeschlagen'); }
  const reader = r.body.getReader();
  const dec = new TextDecoder();
  let puffer = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    puffer += dec.decode(value, { stream: true });
    const teile = puffer.split('\n\n');
    puffer = teile.pop();
    teile.forEach((t) => {
      if (!t.startsWith('data: ')) return;
      const ev = JSON.parse(t.slice(6));
      if (ev.fehler) throw new Error(ev.fehler);
      if (ev.t) onText(ev.t);
      onMeta?.(ev);
    });
  }
};

const fett = (s) => s.split(/(\*\*[^*]+\*\*)/g).map((p, i) => (p.startsWith('**') && p.endsWith('**') ? <strong key={i} className="text-[#1B3A5C]">{p.slice(2, -2)}</strong> : p.replace(/(^|\s)\*([^*\s][^*]*)\*/g, '$1$2')));
export const KiText = ({ text, testId }) => (
  <div className="text-sm text-[#34536b] space-y-1.5 leading-relaxed" data-testid={testId}>
    {text.split('\n').filter((z) => z.trim()).map((z, i) => {
      const t = z.replace(/^#+\s*/, '');
      return /^\s*[-*•]\s/.test(t) ? <p key={i} className="pl-4 relative before:content-['–'] before:absolute before:left-0 before:text-[#b8893d]">{fett(t.replace(/^\s*[-*•]\s/, ''))}</p> : <p key={i}>{fett(t)}</p>;
    })}
  </div>
);

const zeit = (iso) => (iso ? new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');

export const KiZusammenfassung = ({ anfrageId }) => {
  const [s, setS] = useState(null);
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState('');
  useEffect(() => { api.get(`/kanzlei/ki/anfragen/${anfrageId}/zusammenfassung`).then((r) => setS(r.data?.text ? r.data : null)).catch(() => {}); }, [anfrageId]);
  const start = async () => {
    setLaeuft(true); setFehler(''); setS({ text: '' });
    try { await kiStream(`/kanzlei/ki/anfragen/${anfrageId}/zusammenfassung`, {}, (t) => setS((x) => ({ ...x, text: (x?.text || '') + t }))); setS((x) => ({ ...x, am: new Date().toISOString(), von: 'Sie' })); } catch (e) { setFehler(e.message); setS(null); } finally { setLaeuft(false); }
  };
  return (
    <section className="sm:col-span-2 rounded-xl border border-[#b8893d]/30 bg-gradient-to-br from-[#fbf7f0] to-white p-4" data-testid="ki-zusammenfassung">
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <Sparkles className="w-4 h-4 text-[#b8893d]" />
        <h4 className="text-[10px] tracking-[0.2em] uppercase text-[#8a6520] font-semibold flex-1">KI-Zusammenfassung</h4>
        <button type="button" onClick={start} disabled={laeuft} data-testid="ki-zusammenfassen-btn"
          className="inline-flex items-center gap-1.5 text-[11px] tracking-wider px-3 py-1.5 rounded-full bg-[#1B3A5C] text-white hover:bg-[#15304d] disabled:opacity-60 transition-colors duration-200">
          {laeuft ? <Loader2 className="w-3 h-3 animate-spin" /> : s ? <RefreshCw className="w-3 h-3" /> : <Sparkles className="w-3 h-3 text-[#e0b56a]" />}{s ? 'NEU ERSTELLEN' : 'MIT KI ZUSAMMENFASSEN'}
        </button>
      </div>
      {fehler && <p className="text-xs text-rose-700" data-testid="ki-zusammenfassung-fehler">{fehler}</p>}
      {s?.text ? <KiText text={s.text} testId="ki-zusammenfassung-text" /> : !laeuft && <p className="text-xs text-[#7a8a99]">Kernanliegen, Fristen und fehlende Unterlagen auf einen Blick – erstellt von Claude. Bitte vor Verwendung prüfen.</p>}
      {s?.am && <p className="text-[10px] text-[#7a8a99] mt-2">Erstellt {zeit(s.am)}{s.von ? ` · ${s.von}` : ''}</p>}
    </section>
  );
};

const FELD = [['art', 'Art'], ['absender', 'Absender'], ['behoerde_aktenzeichen', 'Aktenzeichen'], ['datum', 'Datum'], ['betrag', 'Betrag'], ['naechster_schritt', 'Nächster Schritt']];
const tag = (v) => (/^\d{4}-\d{2}-\d{2}$/.test(v || '') ? new Date(`${v}T12:00:00`).toLocaleDateString('de-DE') : v);

export const KiAuswertung = ({ e, onClose }) => (
  <div className="rounded-xl border border-[#b8893d]/30 bg-white p-4 mt-3" data-testid="ki-auswertung">
    <div className="flex items-center gap-2 mb-2"><Sparkles className="w-4 h-4 text-[#b8893d]" /><h4 className="text-[10px] tracking-[0.2em] uppercase text-[#8a6520] font-semibold flex-1">KI-Auswertung{e.datei ? ` · ${e.datei}` : ''}</h4>
      <button type="button" onClick={onClose} className="text-[11px] text-[#7a8a99] hover:text-[#1B3A5C]">Schließen</button></div>
    {e.frist_datum && <p className="mb-2 inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-rose-50 text-rose-700 border border-rose-200" data-testid="ki-auswertung-frist"><CalendarClock className="w-3.5 h-3.5" />Frist: {tag(e.frist_datum)}{e.frist_hinweis ? ` · ${e.frist_hinweis}` : ''}</p>}
    {e.zusammenfassung && <p className="text-sm text-[#1B3A5C] mb-2">{e.zusammenfassung}</p>}
    <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-1">{FELD.filter(([k]) => e[k] != null && e[k] !== '').map(([k, l]) => (
      <div key={k} className="grid grid-cols-[110px_1fr] gap-2 text-xs"><dt className="text-gray-500">{l}</dt><dd className="text-[#1B3A5C]">{k === 'betrag' ? Number(e[k]).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) : tag(e[k])}</dd></div>))}</dl>
    <p className="text-[10px] text-[#7a8a99] mt-2">Erstellt von Claude{e.am ? ` · ${zeit(e.am)}` : ''} – Fristen bitte immer selbst prüfen.</p>
  </div>
);
